export default __webpack_public_path__ + "static/media/checked_icon.d07a7649.svg";